import React from 'react';
import { Row, Col } from 'antd';
import Text from 'antd/lib/typography/Text';
import Link from 'antd/lib/typography/Link';
import Currency from '../currency/currency';
import { useDispatch } from 'react-redux';
import { actionCreators as BookingActions } from '../../store/Booking';
import { actionCreators as InvoiceActions } from '../../store/Invoice';

export interface ISummarySubtotalItemProps {
    long?: boolean;
    label: string;
    value?: number;
    currency: string;
    locale: string;
    translationKey?: string | undefined;
    className?: string;
    showCode?: boolean;
    removeCode?: string;
    removeAddOn?: number;
    removeDigitalAddOn?: number;
}

const SummarySubtotalItem: React.FunctionComponent<ISummarySubtotalItemProps> = (props) => {
    const dispatch = useDispatch();

    const onRemoveClicked = () => {
        if (props.removeCode) {
            dispatch(BookingActions.removeCode(props.removeCode));
            dispatch(InvoiceActions.removeCode(props.removeCode));
        }
        if (props.removeAddOn) {
            dispatch(BookingActions.removeAddOn(props.removeAddOn));
        }
        if (props.removeDigitalAddOn) {
            dispatch(BookingActions.removeDigitalAddOn(props.removeDigitalAddOn));
        }
    };

    if (props.value === undefined) return <React.Fragment />;
    if (props.currency === undefined || props.currency === '') return <React.Fragment />;

    if (props.long)
        return (
            <Row
                align="middle"
                justify="end"
                className={`subtotal-item ${props.className !== undefined ? `${props.className}` : ''}`}
            >
                <Col span={24}>
                    <Currency
                        translationKey={props.label}
                        value={props.value}
                        locale={props.locale}
                        currency={props.currency}
                    />
                </Col>
            </Row>
        );

    return (
        <Row
            align="middle"
            justify="end"
            className={`subtotal-item  ${props.className !== undefined ? `${props.className}` : ''}`}
        >
            <Col span={14}>
                <Text strong>
                    {props.label} {(props.removeCode || props.removeAddOn || props.removeDigitalAddOn) && <Link className="remove-code-link" onClick={() => onRemoveClicked()}>[X]</Link>}
                </Text>
            </Col>
            <Col span={10} className="currency">
                <Currency
                    value={props.value}
                    locale={props.locale}
                    currency={props.currency}
                    showCode={props.showCode}
                />
            </Col>
        </Row>
    );
};

export default SummarySubtotalItem;
